import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { IonSearchbar } from "@ionic/react";

import { translate } from "~utils";

type IndexSearchProps = {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
};

export function IndexSearch(props: IndexSearchProps) {
  const { searchTerm, setSearchTerm } = props;

  const input = useRef<HTMLIonSearchbarElement>(null);

  useEffect(() => {
    input.current?.getInputElement().then((native) => native?.focus());
  }, []);

  return (
    <div className="mw-800">
      <IonSearchbar
        className="searchbar"
        showClearButton="always"
        showCancelButton="never"
        placeholder={translate("INDEX_SEARCH_BAR_PLACEHOLDER")}
        ref={input}
        value={searchTerm}
        onIonInput={(e) => setSearchTerm(e?.target?.value || "")}
        debounce={400}
      ></IonSearchbar>
    </div>
  );
}
